<template>
  <div id="app" class="carteira-de-pesca">
    <div class="container">
      <Greeting />
      <LicenseSection />
      <HistoricoLicencas />
    </div>
  </div>
</template>

<style scoped>
@media (max-width: 768px) {
  .container {
    flex-direction: row;
    justify-content: space-between;
    max-width: 90vw !important;
  }
}
</style>

<script>
import Greeting from "../layouts/Greeting.vue";
import LicenseSection from "../layouts/LicenseSection.vue";
import HistoricoLicencas from "../business/historico/HistoricoLicencas.vue"; // Importando o componente

export default {
  components: {
    Greeting,
    LicenseSection,
    HistoricoLicencas // Registrando o componente
  }
};
</script>
